import { Permission } from 'api/types';
import useOPUserQuery from 'hooks/useOPUserQuery';
import { useTranslation } from 'react-i18next';
import { CgProfile } from 'react-icons/cg';
import { useParams } from 'react-router-dom';

import { ContentCard } from '../../layout/ContentCard';
import UserForm from './UserForm';

const UserFormPage = () => {
  const { t } = useTranslation('user');
  const { id } = useParams();
  const userId = id ? Number(id) : null;
  const userQuery = useOPUserQuery(userId);

  return (
    <ContentCard
      header={id ? t('form.header.update') : t('form.header.create')}
      maxWidth={{ base: 'full', xl: '75%' }}
      icon={<CgProfile size="40" />}
      isLoading={userQuery.isLoading || userQuery.isFetching}
    >
      {!userId && (
        <UserForm
          defaultValues={{
            name: '',
            email: '',
            language: 'DE',
            spokenLanguages: [],
            roles: [],
            permissionNames: [], // User type is wrong
            timezone: '',
          }}
        />
      )}
      {userId && (
        <UserForm
          userId={userId ?? undefined}
          defaultValues={{
            name: userQuery.data?.name ?? '',
            email: userQuery.data?.email ?? '',
            language: userQuery.data?.language ?? 'DE',
            spokenLanguages: userQuery.data?.spoken_languages ?? [],
            roles: userQuery.data?.roles ?? [],
            permissionNames: (userQuery.data?.permissions as unknown as Permission[] | undefined)?.map((p) => p.name) ?? [], // User type is wrong
            timezone: userQuery.data?.timezone ?? '',
          }}
        />
      )}
    </ContentCard>
  );
};

export default UserFormPage;
